import { Empty } from 'antd';
import { useContext } from 'react';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { tags } from '@/constants/Tags';

export default function EmptyThemesSearch({ themes, loading, showFavourites }) {
  const navigationContext = useContext(NavigationContext);

  const selectedTagName = tags.find(
    (tag) => tag.id == navigationContext.state.selectedTagId
  )?.englishName;

  if (themes.length > 0 || loading) {
    return null;
  }

  return (
    <div className="w-100">
      <Empty
        description={
          <>
            No{' '}
            {selectedTagName ? `${selectedTagName.toLowerCase()}-level ` : ''}
            results found{' '}
            {showFavourites ? (
              <>
                in your <strong>favourites</strong>
              </>
            ) : (
              <>for your search</>
            )}
          </>
        }
      />
    </div>
  );
}
